const GA_USER_ID_KEY = "ga_user_id";

/**
 * localStorageからga_user_idを取得、存在しない場合は新規生成して保存
 */
export const getOrCreateGaUserId = (): string => {
  let userId = localStorage.getItem(GA_USER_ID_KEY);

  if (!userId) {
    userId = "viewer-" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(GA_USER_ID_KEY, userId);
  }

  return userId;
};

